import React from "react";
import DataTable from "../DataTableComponent/DataTableComponent";
import { FontAwesome as Icon } from "@expo/vector-icons";
import { View } from "react-native";
import { IDataTableProps } from "react-data-table-component";

interface IReportTableProps {
  data: any;
  tableColumns: any;
  depth?: number;
}

interface IReportTableViewComponent extends IDataTableProps<any> {}

const ReportTableViewComponent = (props: IReportTableViewComponent) => {
  return (
    <DataTable
      {...props}
      striped={true}
      headRowStyle={{ backgroundColor: "#e5e5e5", minHeight: "0px" }}
      expandableIcon={{
        collapsed: <Icon name="plus-square" color="black" size={16} />,
        expanded: <Icon name="minus-square" color="#f25278" size={16} />,
      }}
    />
  );
};

const ChildTable = (props) => {
  const { checkpoints } = props.data;
  return <ReportTable {...props} data={checkpoints} />;
};

const ReportTable = (props: IReportTableProps) => {
  const { data, tableColumns, depth = 0 } = props;
  let componentToRender = null;
  const tableTypes = Array.from(new Set(data.map((obj) => obj.display_type)));
  const tableTypesObj = {};
  tableTypes.forEach((value: string) => {
    tableTypesObj[value] = data.filter((obj) => obj.display_type == value);
  });

  for (const key in tableTypesObj) {
    const columns = tableColumns[key];
    const tableData = tableTypesObj[key];
    const isExpandableRow =
      tableData.reduce((acc, obj) => {
        acc.push(...obj.checkpoints);
        return acc;
      }, []).length > 0;
    componentToRender = (
      <>
        {componentToRender}
        <ReportTableViewComponent
          columns={columns}
          data={tableData}
          keyField={"node_id"}
          overflowYOffset={depth > 0 ? "0px" : "390px"}
          expandableRows={isExpandableRow}
          expandableRowDisabled={(row) =>
            !(!!row.checkpoints && row.checkpoints.length > 0)
          }
          expandableRowsComponent={
            <ChildTable depth={depth + 1} tableColumns={tableColumns} />
          }
        />
      </>
    );
  }
  return !!componentToRender ? (
    <View style={{ marginLeft: depth === 0 ? depth : 20 }}>
      {componentToRender}
    </View>
  ) : (
    <ReportTableViewComponent columns={tableColumns["Car Part"]} data={[]} />
  );
};

export default ReportTable;
